import { render, staticRenderFns } from "./WordCloudCom.vue?vue&type=template&id=e7d2c6dc&"
import script from "./WordCloudCom.vue?vue&type=script&lang=js&"
export * from "./WordCloudCom.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudCom.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports